/* Custom product purchases use the theme's native mini cart and localized Ajax API. */
(function () {
  'use strict';
  var pending = new WeakSet();
  function route(name, fallback) {
    return (window.routes && window.routes[name]) || ((window.Shopify && window.Shopify.routes.root) || '/') + fallback;
  }
  function notice(trigger, message, error) {
    var host = trigger && trigger.parentElement;
    if (!host) return;
    var node = host.querySelector('.atm-cart-status');
    if (!node) {
      node = document.createElement('div');
      node.className = 'atm-cart-status';
      host.appendChild(node);
    }
    node.setAttribute('role', error ? 'alert' : 'status');
    node.textContent = message;
  }
  function label(name, fallback) {
    var config = document.getElementById('atm-cart-messages');
    return config && config.dataset[name] || fallback;
  }
  async function add(items, trigger, context) {
    var lock = context || trigger;
    if (lock && pending.has(lock)) return;
    if (lock) pending.add(lock);
    var disabled = trigger && trigger.disabled;
    if (trigger) {
      trigger.disabled = true;
      trigger.setAttribute('aria-busy', 'true');
      notice(trigger, '', false);
    }
    try {
      var mini = document.querySelector('mini-cart');
      var sections = mini ? mini.getSectionsToRender().map(function (s) { return s.section; }) : [];
      var response = await fetch(route('cart_add_url', 'cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
      });
      var result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || label('error', 'Unable to add item.'));
      // Once accepted, never retry the add request if rendering or analytics fails.
      notice(trigger, label('added', 'Added to cart'), false);
      try {
        if (mini) { mini.renderContents(result); mini.open(trigger); }
      } catch (renderError) { console.error('Mini cart rendering failed', renderError); }
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartItemAdd, { source: context && context.dataset.eventContext || 'product-form', items: result.items || [result] });
        }
      } catch (eventError) { console.error('Cart event failed', eventError); }
      return result;
    } catch (error) {
      notice(trigger, error.message || label('error', 'Unable to add item.'), true);
    } finally {
      if (lock) pending.delete(lock);
      if (trigger) { trigger.disabled = disabled; trigger.removeAttribute('aria-busy'); }
    }
  }
  function addForm(form, trigger) {
    trigger = trigger || form.querySelector('[type="submit"]');
    var productForm = form.closest('product-form');
    if (productForm && typeof productForm.validateRequiredFields === 'function') {
      if (!productForm.validateRequiredFields()) return;
    } else if (!form.reportValidity()) return;
    var data = new FormData(form);
    var item = { id: data.get('id'), quantity: parseInt(data.get('quantity') || '1', 10), properties: {} };
    if (!item.id) return;
    data.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match) item.properties[match[1]] = value;
    });
    if (data.get('selling_plan')) item.selling_plan = data.get('selling_plan');
    var items = [item];
    document.querySelectorAll('.atm-services[data-form]').forEach(function (root) {
      if (root.dataset.form !== form.getAttribute('id')) return;
      root.querySelectorAll('.atm-services__cb:checked').forEach(function (box) { items.push({ id: box.value, quantity: 1 }); });
    });
    if (form.dataset.atmCoreVariant) items.push({ id: form.dataset.atmCoreVariant, quantity: item.quantity, properties: { _core: 'true', _core_for: String(item.id) } });
    return add(items, trigger, form);
  }
  window.ATMCart = { add: add, addForm: addForm };
})();
